export const visit = (vm, at) => {
at({ "pt-br": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "Nova mensagem" } } } });
};